<template>
    <!-- Modal de Movimentação de Equipamento -->
    <v-dialog
        v-model="visible"
        max-width="600px"
        persistent
    >
        <v-card>

            <v-toolbar color="primary" dark>

                <div 
                    class="d-flex align-center white--text" 
                    style="white-space: nowrap; overflow: visible; margin-left: 10px; font-size: 20px;"
                >
                    <v-icon class="mr-2">mdi-truck</v-icon>
                    Registro Equipamento {{ dadosOrigem.equipamento }}
                </div>
                
                <v-spacer />
                
                <v-btn icon @click="fecharModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="pa-6">

                <v-form ref="formRef">
                
                    <v-text-field
                        v-model="dadosOrigem.equipamento"
                        label="Equipamento"
                        readonly
                        class="mb-4"
                    />

                    <v-text-field
                        v-model="dadosOrigem.nomeEmpresaOrigem"
                        label="Empresa de Origem"
                        readonly
                        class="mb-4"
                    />

                    <v-text-field
                        v-model="dadosOrigem.nomeSetorOrigem"
                        label="Setor de Origem"
                        readonly
                        class="mb-4"
                    />

                    <v-text-field
                        v-model="dadosOrigem.nomeEmpresaDestino"
                        label="Empresa de Destino"
                        readonly
                        class="mb-4"
                    />

                    <v-text-field
                        v-model="dadosOrigem.nomeSetorDestino"
                        label="Setor de Destino"
                        readonly
                        class="mb-4"
                    />

                    <v-text-field
                        v-model="dadosOrigem.quemMovimentou"
                        label="Quem Movimentou"
                        readonly
                        class="mb-4"
                    />

                    <v-text-field
                        v-model="dadosOrigem.dataMovimento"
                        label="Data da Movimentação"
                        readonly
                        class="mb-4"
                    />

                    <!-- Motivo da Movimentação -->
                    <v-textarea
                        v-model="dadosOrigem.motivoMovimento"
                        label="Motivo da Movimentação *"
                        readonly
                        rows="3"
                        auto-grow
                        class="mb-4"
                    />

                </v-form>
            
            </v-card-text>

            <v-card-actions class="pa-4 pt-0">
                
                <v-spacer />
                
                <v-btn
                    variant="outlined"
                    @click="fecharModal"
                    class="mr-2"
                >
                    Fechar
                </v-btn>
                
            </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<script setup>

    // Importa referências do vue
    import { ref, defineEmits } from 'vue'
    
    // IMporta biblioteca axios http
    import axios from 'axios'

    // Importa store de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa store de erro
    import { useErroStore } from '@/stores/erroStore'

    // Retorna um objeto com informações internas sobre o componente que está sendo executado no momento    
    import { getCurrentInstance } from 'vue'

    // Permite acessar rotinas globais
    const { proxy } = getCurrentInstance()

    // Monta endereço da api
    const API_BASE_URL = import.meta.env.VITE_API_URL           
            
    // Define a emissão de comando para o formulário que chamou indicando que fechou o modal
    const emit = defineEmits(['movimentacao-concluida', 'fechar'])

    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Estado do modal
    const visible = ref(false)

    // Dados da origem (preenchidos quando abre o modal)
    const dadosOrigem = ref({
        equipamento: null,
        nomeEmpresaOrigem: null,
        nomeSetorOrigem: null,
        nomeEmpresaDestino: null,
        nomeSetorDestino: null,
        quemMovimentou: null,
        dataMovimento: null,
        motivoMovimento: null,
    })
    
    // Metodo para abrir formulário modal
    const abrirModal = async (dados) => {

        try {
            
            const idRegistroMovimentacoes = dados.idRegistroMovimentacoes

            // Carrega lista de empresas
            const { data } = await axios.get(`${API_BASE_URL}/operacao/carregaDadosMovimentacao/${idRegistroMovimentacoes}`, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            const retornoApi = data.data

            dadosOrigem.value.equipamento = retornoApi.equipamento
            dadosOrigem.value.nomeEmpresaOrigem = retornoApi.nomeEmpresaOrigem
            dadosOrigem.value.nomeSetorOrigem = retornoApi.nomeSetorOrigem
            dadosOrigem.value.nomeEmpresaDestino = retornoApi.nomeEmpresaDestino
            dadosOrigem.value.nomeSetorDestino = retornoApi.nomeSetorDestino
            dadosOrigem.value.quemMovimentou = retornoApi.quemMovimentou
            dadosOrigem.value.dataMovimento = proxy.$formataDataBrasil(retornoApi.dataMovimento)
            dadosOrigem.value.motivoMovimento = retornoApi.motivoMovimento

            

            // Abre o modal
            visible.value = true

        } catch (erro) {    
            erroStore.exibirErro(erro)('Erro Ao Preparar Movimentação: ' + erro)
        }
    }

    // Metodo para que fecha o modal
    const fecharModal = () => {
        visible.value = false
        emit('fechar')
    }

    // Expor métodos para o componente pai
    defineExpose({
        abrirModal,
        fecharModal
    })

</script>

<style scoped>

    .v-card-text {
        padding-top: 20px;
    }

    .v-textarea textarea {
        min-height: 80px;
    }

</style>